import { LitElement, html, css, TemplateResult } from "lit";
import { unsafeHTML } from "lit-html/directives/unsafe-html.js";
import { customElement, property, query } from "lit/decorators.js";
import "@shoelace-style/shoelace/dist/components/alert/alert.js";
import "@shoelace-style/shoelace/dist/components/details/details.js";
import "@shoelace-style/shoelace/dist/components/icon-button/icon-button.js";
import { Reading, MonitoringOverviewItem } from "../../endpoints/endpoint_types.js";
import "./monitor_details";

const PRIORITY_MEDIUM = 500;

/**
 * Display a row of data for a URL.
*/
@customElement("url-widget")
export class UrlWidget extends LitElement {
    constructor() {
        super();
    }

    @property({ type: Object }) data: {
        overview: MonitoringOverviewItem[];
    } | null = null;

    @property({ type: Object }) error: TemplateResult | null = null;

    @property({ type: Boolean }) dirty = false;

    async loadData() {
        try {
            const response = await fetch("./data/monitoringoverview");
            if (!response.ok) {
                const errorBody = new DOMParser().parseFromString(await response.text(), "text/html").body.innerHTML;
                this.error = html`<strong>
                    <div>Data was not loaded.</div>
                    <div>${response.status} ${response.statusText}</div>
                </strong>
                <div>${unsafeHTML(errorBody)}</div>`;
                return;
            }
            this.data = await response.json();
            this.error = null;
            console.log('data', JSON.stringify(this.data));
        } catch (error) {
            console.error("Failed to fetch data:", error);
            this.error = html`<div>Failed to fetch data: ${String(error)}</div>`;
        }
    }

    async firstUpdated() {
        await this.loadData();
        this.addEventListener("listing-priority-changed", async () => {
            await this.loadData();
        });
    }

    async updated(changedProps: Map<string, any>) {
        if (this.dirty) {
            await this.loadData();
            this.dirty = false;
        }
    }

    render() {
        if (this.error) {
            return html`<sl-alert variant="warning" open>
                <sl-icon slot="icon" name="info-circle"></sl-icon>
                ${this.error}
            </sl-alert>`;
        }

        if (!this.data) {
            return html`<div>Loading...</div>`;
        }

        const active = this.data.overview.filter(i => i.priority >= PRIORITY_MEDIUM);
        const snoozed = this.data.overview.filter(i => i.priority < PRIORITY_MEDIUM);

        return html`
            ${active.map(this.renderUrlRow.bind(this))}
            ${snoozed.length > 0 ? html`
                <sl-details class="snoozed-section">
                    <span slot="summary">Snoozed (${snoozed.length})</span>
                    ${snoozed.map(this.renderUrlRow.bind(this))}
                </sl-details>
            ` : ''}
        `;
    }

    renderUrlRow(data: MonitoringOverviewItem) {
        return html`
            <monitor-details .reading="${data}">
            </monitor-details>
        `;
    }

    static styles = css`
        .snoozed-section {
            margin-top: 20px;
            opacity: 0.7;
        }
    `;
}
